import React from 'react';
import { ProjetoDisciplinasQuery_disciplinas } from '../../graphql/queries/__generated__/ProjetoDisciplinasQuery';
import { ProjetoOfertasQuery_ofertas } from '../../graphql/queries/__generated__/ProjetoOfertasQuery';
import { ProjetoProfessoresQuery_professores } from '../../graphql/queries/__generated__/ProjetoProfessoresQuery';
import { Form, FormField } from '../../../shared/components/form_components/form';
import { InputForm } from '../../../shared/components/form_components/input';
import { InputSelect } from '../../../shared/components/form_components/select';

interface Props {
  projeto?: FormProjeto;
  ofertas?: ProjetoOfertasQuery_ofertas[];
  professores?: ProjetoProfessoresQuery_professores[];
  disciplinas?: ProjetoDisciplinasQuery_disciplinas[];
  onSubmit: (projeto: FormProjeto) => void;
  onCancel?: () => void;
}

interface FormProjeto {
  id_projeto_pedagogico?: number;
  id_oferta: number;
  id_professor: number;
  id_disciplina: number;
  ind_semestre: number;
  ind_ordem: number;
  num_carga_horaria_to?: number;
  dsc_modalidade?: string;
  dsc_sigla_disciplina?: string;
}

const MODALIDADE_OPTIONS = [
  { label: 'Presencial', value: 'Presencial' },
  { label: 'EAD', value: 'EAD' },
  { label: 'EAD com aulas ao vivo', value: 'EAD com aulas ao vivo' },
  { label: 'Híbrido', value: 'Híbrido' },
];

const FormularioProjeto: React.FC<Props> = (props) => {
  const fields: FormField[] = [
    {
      name: 'id_projeto',
      label: 'Id do projeto',
      type: 'number',
      defaultValue: props.projeto?.id_projeto_pedagogico,
      required: true,
      disabled: true,
      component: InputForm,
    },
    {
      name: 'id_oferta',
      label: 'Id da oferta',
      type: 'number',
      defaultValue: props.projeto?.id_oferta,
      items: props.ofertas?.map((o) => ({
        label: o.curso?.dsc_sigla_curso + ' - ' + o.num_ano + '/' + o.num_oferta || '',
        value: o.id_oferta,
      })),
      required: true,
      readOnly: true,
      component: InputSelect,
    },
    {
      name: 'id_professor',
      label: 'Id do professor',
      type: 'number',
      defaultValue: props.projeto?.id_professor,
      items: props.professores?.map((p) => ({
        label: p.dsc_nome_professor || '',
        value: p.id_professor,
      })),
      required: true,
      readOnly: true,
      component: InputSelect,
    },
    {
      name: 'id_disciplina',
      label: 'Id da disciplina',
      type: 'number',
      defaultValue: props.projeto?.id_disciplina,
      items: props.disciplinas?.map((d) => ({
        label: d.dsc_sigla + ' - ' + d.num_carga_horaria + 'h' || '',
        value: d.id_disciplina,
      })),
      required: true,
      readOnly: true,
      component: InputSelect,
    },
    {
      name: 'ind_semestre',
      label: 'Semestre',
      type: 'number',
      defaultValue: props.projeto?.ind_semestre,
      required: true,
      disabled: false,
      component: InputForm,
    },
    {
      name: 'ind_ordem',
      label: 'Ordem',
      type: 'number',
      defaultValue: props.projeto?.ind_ordem,
      required: true,
      disabled: false,
      component: InputForm,
    },
    {
      name: 'num_carga_horaria_to',
      label: 'Horas TO',
      type: 'number',
      defaultValue: props.projeto?.num_carga_horaria_to,
      required: false,
      disabled: false,
      component: InputForm,
    },
    {
      name: 'dsc_modalidade',
      label: 'Modalidade',
      type: 'text',
      defaultValue: props.projeto?.dsc_modalidade,
      items: MODALIDADE_OPTIONS,
      required: false,
      readOnly: true,
      component: InputSelect,
    },
    {
      name: 'dsc_sigla_disciplina',
      label: 'Sigla Disciplina (oferta)',
      type: 'text',
      defaultValue: props.projeto?.dsc_sigla_disciplina,
      required: false,
      disabled: false,
      component: InputForm,
    },
  ];

  return (
    <Form
      fields={fields}
      form_name='projeto'
      is_edit={Boolean(props.projeto)}
      onSubmit={props.onSubmit}
      onCancel={props.onCancel}
    />
  );
};

export { FormularioProjeto };
export type { FormProjeto };
